import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout } from "../../../../components/src/signin/signin-components/auth-layout.component";
import { StepSignUp } from "./signup-steps/step-sign-up";

export const SignupPage: React.FC = () => {
	const navigate = useNavigate();

	const handleSignupComplete = () => {
		navigate('/onboarding?show_migration_step');
	};

	return (
		<AuthLayout title="Willkommen bei dentLAB" subtitle="Registrieren Sie sich mit Ihrer Admin-Email und Ihrem Zugangscode.">
			<StepSignUp
				canGoBack={false}
				stepNumber={0}
				totalSteps={1}
				onComplete={handleSignupComplete}
			/>
		</AuthLayout>
	);
};
